import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../utils/api";

// Async Thunk for Category API Call
export const fetchAppBrand = createAsyncThunk(
  "appliance_brand/fetchAppBrand",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get("/appliance-brands");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

// export const fetchCategoryProducts = createAsyncThunk(
//   "appliance_category/fetchCategoryProducts",
//   async ({ categoryId, page = 1, perPage = 10 }, { rejectWithValue }) => {
//     try {      
//       const response = await API.get(`/categoryproduct/${categoryId}?page=${page}&perPage=${perPage}`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Something went wrong");
//     }
//   }
// );

const appBrandSlice = createSlice({
  name: "appliance_brand",
  initialState: {
    app_brands: [],
    app_brand_products: [],
    app_brand_loading: false,
    app_brand_error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppBrand.pending, (state) => {
        state.app_brand_loading = true;
      })
      .addCase(fetchAppBrand.fulfilled, (state, action) => {
        state.app_brand_loading = false;
        state.app_brands = action.payload;
      })
      .addCase(fetchAppBrand.rejected, (state, action) => {
        state.app_brand_loading = false;
        state.app_brand_error = action.payload;
      })
    //   .addCase(fetchCategoryProducts.pending, (state) => {
    //     state.app_brand_loading = true;
    //   })
    //   .addCase(fetchCategoryProducts.fulfilled, (state, action) => {
    //     state.app_brand_loading = false;
    //     state.cat_products = action.payload;
    //   })
    //   .addCase(fetchCategoryProducts.rejected, (state, action) => {
    //     state.app_brand_loading = false;
    //     state.app_brand_error = action.payload;
    //   });
  },
});

export default appBrandSlice.reducer;
